import * as $ from 'jquery';
import {safeLocalStorage} from './utils/safeLocalStorage.js';

// avoid sending duplicated signup requests
$(document).on('submit', '#signup-form', function(e){
    const conditionsCheckbox = document.getElementById('termsConditionsCheckbox');
    if(conditionsCheckbox != null && !conditionsCheckbox.checked) {
        e.preventDefault();
        conditionsCheckbox.classList.add('is-invalid');
        document.querySelector('.js-gdpr-not-checked').classList.remove('d-none');
        conditionsCheckbox.scrollIntoView({ block: 'center',  behavior: 'smooth' });
    } else {
        safeLocalStorage.setItem("newRegister", "true");
        document.querySelectorAll('#signup-form button[type="submit"]').forEach((el) => {
            el.disabled = true;
        });
    }
});